module.exports = __webpack_public_path__ + "static/media/skeleton_king.93ca5584.png";